module.exports = __webpack_public_path__ + "img/19.6741b4a3.jpg";